export default "__VITE_ASSET__75b0378d__"